/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioVolumeS0Icon16Light } from './MediaAudioVolumeS0Icon16Light';
import { MediaAudioVolumeS0Icon16Regular } from './MediaAudioVolumeS0Icon16Regular';
import { MediaAudioVolumeS0Icon16Solid } from './MediaAudioVolumeS0Icon16Solid';
import { MediaAudioVolumeS0Icon20Light } from './MediaAudioVolumeS0Icon20Light';
import { MediaAudioVolumeS0Icon20Regular } from './MediaAudioVolumeS0Icon20Regular';
import { MediaAudioVolumeS0Icon20Solid } from './MediaAudioVolumeS0Icon20Solid';
import { MediaAudioVolumeS0Icon24Regular } from './MediaAudioVolumeS0Icon24Regular';
import { MediaAudioVolumeS0Icon24Solid } from './MediaAudioVolumeS0Icon24Solid';
import { MediaAudioVolumeS0Icon32Regular } from './MediaAudioVolumeS0Icon32Regular';
import { MediaAudioVolumeS0Icon64Regular } from './MediaAudioVolumeS0Icon64Regular';
var sizes = {
    16: {
        light: MediaAudioVolumeS0Icon16Light,
        regular: MediaAudioVolumeS0Icon16Regular,
        solid: MediaAudioVolumeS0Icon16Solid,
    },
    20: {
        light: MediaAudioVolumeS0Icon20Light,
        regular: MediaAudioVolumeS0Icon20Regular,
        solid: MediaAudioVolumeS0Icon20Solid,
    },
    24: {
        regular: MediaAudioVolumeS0Icon24Regular,
        solid: MediaAudioVolumeS0Icon24Solid,
    },
    32: {
        regular: MediaAudioVolumeS0Icon32Regular,
    },
    64: {
        regular: MediaAudioVolumeS0Icon64Regular,
    },
};
export var MediaAudioVolumeS0Icon = forwardRef('MediaAudioVolumeS0Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
